import React, { useEffect } from 'react';
import './cancelPage.css';
import cancelAnimation from '../../assets/lottie/cancel.json';
import Lottie from 'lottie-react';

const CancelPage = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const allParams = Object.fromEntries(params.entries());

    console.log("[payment-cancel] query params", allParams);
    console.log("[payment-cancel] summary", {
      xResult: params.get("xResult"),
      xStatus: params.get("xStatus"),
      xError: params.get("xError"),
      xErrorCode: params.get("xErrorCode"),
      xInvoice: params.get("xInvoice"),
      xRefNum: params.get("xRefNum"),
    });
  }, []);

  return (
    <div className="cancel-container">
      <div className="cancel-card">
        <Lottie animationData={cancelAnimation} loop={false} className="cancel-animation" />
        <h1 className="cancel-title">Payment Cancelled</h1>
        <p className="cancel-message">
          Your payment was not completed. Please try again or contact support.
        </p>
        <button className="cancel-button" onClick={() => (window.location.href = '/')}>
          Try Again
        </button>
      </div>
    </div>
  );
};

export default CancelPage;
